/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getActivityPage} from '../api'

 export const useQueryGetActivityPage = createReactQueryHook('getActivityPage', getActivityPage)
